<template>
  <div class="medical_circle_today" id="medicalToday">
    <scroller
      :on-refresh="refresh"
      :on-infinite="infinite"
      ref="myscroller"
      class="scroll_box"
      :refreshText="text"
    >
      <ul class="dailyInfo_list" v-if="list.length > 0">
        <li v-for="(item, index) in list" :key="index">
          <p class="show_time">{{ item.time | todayMedical }}</p>
          <ul>
            <li
              v-for="(itemT, indexT) in item.list"
              :key="itemT.infoId"
              :class="[
                'dailyInfo_list_in_list',
                indexT !== 0 ? 'vux-1px-t' : ''
              ]"
              @click="toHeadline(itemT.id)"
            >
              <!-- {{itemT}} -->
              <div v-if="itemT.isTopTitle == 1" class="first">
                <img :src="itemT.cover_url" alt="" />
                <p>{{ itemT.title }}</p>
              </div>
              <div v-else class="other">
                <div>
                  <img :src="itemT.cover_url" alt="" />
                </div>
                <p>{{ itemT.title }}</p>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </scroller>
    <div class="medical_circle_today_bottom">
      <!-- <p class="top_content">
                <span>我对医疗资讯不感兴趣，</span>
                <span @click="noUpdate">不需要更新提醒</span>
                <span>订阅人数: {{subPerson}}</span>
            </p> -->
      <button class="bottom_btn" @click="toHome">进入首页观看医学讲座</button>
    </div>
    <div v-if="openWindow" class="update_page" @touchmove.prevent>
      <div class="popup_box">
        <p class="top vux-1px-b">是否确定不再接收资讯更新提醒</p>
        <div class="bottom">
          <button class="vux-1px-r" @click="needUpdate(0)">是</button>
          <button @click="needUpdate(1)">否</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { medicalCircle } from '@/api/ajax.js';
import { InlineLoading } from 'vux';
export default {
  name: 'MedicalCircleToday', // 今日医疗圈页面
  props: {},
  data() {
    return {
      subPerson: 44240,
      pageNo: 1,
      list: [],
      openWindow: false,
      text: '下拉加载往期内容',
      loadMore: true
    };
  },
  methods: {
    refresh(done) {
      if (!this.loadMore) {
        setTimeout(() => {
          this.$refs.myscroller.finishInfinite(true);
          done();
          this.text = '没有更早的内容了';
          this.$nextTick(_ => {
            document.querySelector('.arrow').style.display = 'none';
          });
        });
        return;
      } else {
        this.pageNo++;
        this.loadMore = false;
        medicalCircle.list('?pageNo=' + this.pageNo).then(res => {
          let resp = res.data.data;
          this.list.unshift(resp);
          console.log(resp);
          if (!resp.hasMore) {
            // 已经没有数据了。
            this.loadMore = false;
            done(false);
          } else {
            this.loadMore = true;
            done(true);
          }
          this.$refs.myscroller.resize();
        });
      }
    },
    infinite(done) {},
    toHome() {
      // 去医学V视界首页
      this.$router.push({ path: '/home' });
    },
    toHeadline(data) {
      this.$router.push({
        name: 'headlineDetail',
        params: { id: data, type: 0 }
      });
    },
    noUpdate() {
      this.openWindow = true;
    }
    // needUpdate (data) {
    //     if (data == 0) {
    //         // 不需要更新
    //         medicalCircle.cancelPushInfo({userId: this.$api.getStorage('wxUserInfo').id}).then( res => {
    //             this.$vux.toast.show({
    //                 type: 'text',
    //                 text: '退订成功',
    //                 position: 'middle'
    //             })
    //             this.openWindow = false;
    //         })
    //     }
    //     else {
    //         this.openWindow = false;
    //     }
    // }
  },
  components: {
    InlineLoading
  },
  computed: {},
  created() {
    medicalCircle.list('?pageNo=' + this.pageNo).then(res => {
      if (res.data.data) {
        let resp = res.data.data;
        this.list.push(resp);
        if (!resp.hasMore) {
          // 已经没有数据了。
          this.loadMore = false;
          this.text = '没有更早的内容了';
          this.$nextTick(_ => {
            document.querySelector('.arrow').style.display = 'none';
          });
        }
      } else {
        // 已经没有数据了。
        this.loadMore = false;
        this.text = '没有更早的内容了';
        this.$nextTick(_ => {
          document.querySelector('.arrow').style.display = 'none';
        });
      }
    });
    //   this.$wxShareInfo('今日医疗圈', '今日医疗圈', this.detailObj.coverPic, location.href, shareUrl, shareCallBackFunc)
  },
  mounted() {},
  beforeDestroy() {}
};
</script>
<style lang="less">
._v-container > ._v-content > .pull-to-refresh-layer {
  margin-top: 0 !important;
  height: 0.5rem !important;
}
#medicalToday ._v-container > ._v-content > .pull-to-refresh-layer,
.active {
  background: #e9e9e9 !important;
}
._v-container > ._v-content > .loading-layer .spinner-holder,
._v-container > ._v-content > .pull-to-refresh-layer .spinner-holder {
  display: flex !important;
  flex-direction: row-reverse;
  justify-content: center;
  align-items: center;
  span {
    margin: 0 !important;
  }
}
._v-container > ._v-content > .loading-layer .spinner-holder .arrow,
._v-container > ._v-content > .pull-to-refresh-layer .spinner-holder .arrow {
  margin: 0 0 0 0.2rem !important;
  width: 10px !important;
  height: 10px !important;
}
</style>

<style lang="less" scoped>
.scroll_box {
  padding: 0.52rem 0.4133rem 0;
}
.medical_circle_today {
  width: 100vw;
  min-height: 100vh;
  background: #e9e9e9;
  .dailyInfo_list {
    padding-bottom: 15vh;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    flex-wrap: wrap-reverse;
    // height: 86vh;
    overflow: auto;
    .show_time {
      margin: 0.6rem auto;
      width: 3.6rem;
      text-align: center;
      color: #fff;
      background: rgba(205, 205, 205, 0.5);
      border-radius: 0.1rem;
    }
    ul {
      border: 0.05rem solid #d8d8d8;
      border-radius: 0.2rem;
      background: #fff;
      padding: 0.2rem 0.22rem 0 0.22rem;
      .dailyInfo_list_in_list {
        width: 100%;
        .first {
          position: relative;
          width: 8.6267rem;
          height: 4.88rem;
          img {
            width: 100%;
            height: 100%;
          }
          p {
            position: absolute;
            left: 0;
            bottom: 0;
            padding: 0 0.3rem 0.1rem;
            width: 100%;
            height: 1.25rem;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            color: #fff;
            font-size: 0.45rem;
            line-height: 0.6rem;
            background: rgba(0, 0, 0, 0.7);
          }
        }
        .other {
          display: flex;
          justify-content: flex-start;
          //   align-items: center;
          padding: 0.2rem 0;
          height: 1.5533rem;
          div {
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              width: 1.27rem;
              height: 1.27rem;
            }
          }
          p {
            padding-left: 0.35rem;
            width: 8.2767rem;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            color: #000;
            font-size: 0.4rem;
          }
        }
      }
    }
  }
  .medical_circle_today_bottom {
    position: fixed;
    left: 0;
    bottom: 0;
    padding: 0 0.4133rem;
    width: 100%;
    height: 2.5rem;
    background: #e9e9e9;
    .top_content {
      display: flex;
      align-items: center;
      font-size: 0.2933rem;
      color: #000;
      span:nth-of-type(2) {
        color: #707070;
      }
      span:nth-of-type(3) {
        display: inline-block;
        width: 3.4rem;
        text-align: right;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        color: #027cfa;
      }
    }
    .bottom_btn {
      margin: 0.2rem auto 0;
      display: inline-block;
      width: 100%;
      height: 1.2133rem;
      background: #027cfa;
      color: #fff;
      font-size: 0.4133rem;
      border-radius: 0.1rem;
      border: none;
    }
  }
  .update_page {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    font-size: 0.38rem;
    background: rgba(0, 0, 0, 0.3);
    .popup_box {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 8rem;
      height: 5rem;
      background: #fff;
      border-radius: 0.11rem;
      transform: translate(-50%, -50%);
      overflow: hidden;
      .top {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 3.5rem;
      }
      .bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 1.5rem;
        button {
          padding: 0.2rem 0;
          width: 49%;
          height: 1.1rem;
          background: #fff;
          border: none;
          line-height: 1.5rem;
        }
        button:nth-of-type(2) {
          color: red;
        }
      }
    }
  }
}
</style>
